<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"Master.institute" | translate}}</h5>
</div>
<div class="vetro-bg">
    <p-table #dt [value]="instituteList" styleClass="p-datatable-gridlines" [globalFilterFields]="['name']"
        [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,25,50,100]">
        <ng-template pTemplate="caption">

            <div class="d-flex justify-content-between">
                <span class="p-input-icon-left p-ml-auto" width="300px">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)=" applyFilterGlobal($event,'contains')"
                        placeholder="Search..." />
                </span>
                <div class="d-flex table-action-wrap align-items-center">
                    <p-button type="button" icon="pi pi-plus-circle" pRipple class="btn-link mr-3" pTooltip="Add"
                        tooltipPosition="bottom" iconPos="left" (click)="addModal()"
                        label="{{'commonbtn.add'|translate}}">
                    </p-button>
                     <button class="p-button p-button-raised" type="button" icon="pi pi-check" style="width: 100px; justify-content: center;"
                        (click)="export()">
                            {{ "commonbtn.export" | translate }}
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Company Name</th>
                <th>Address</th>
                <th>Location</th>
                <th>isTestLab</th>
                <th>isTestingBody</th>
                <th>IsCertificationBody</th>
                <!-- <th>Institute Type</th> -->
                <th>Edit</th>
                <th>Activate</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-model>
            <tr
        [style.backgroundColor]="!model.isActive ? '#f4f4f4' : ''"
        [style.color]="!model.isActive ? '#888' : ''"
        [style.opacity]="!model.isActive ? '0.6' : '1'"
      >
                <td>{{model.id}}</td>
                <td>{{model.name}}</td>
                <td>{{model.companyName}}</td>
                <td>{{model.address}}</td>
                <td>{{model.location}}</td>
                <td>{{model.isTestLab ? 'Yes' : 'No'}}</td>
                <td>{{model.isTestingBody ? 'Yes' : 'No'}}</td>
                <td>{{model.isCertificationBody? 'Yes' : 'No'}}</td>
                <!-- <td>{{model.instituteType.name}}</td> -->
                <td> <a class="pi pi-pencil" style="color:#fddc88; text-align:center;" (click)="edit(model)"></a>
                </td>
                <td>
          <p-inputSwitch
            [style]="{ marginLeft: '1rem' }"
            [(ngModel)]="model.isActive"
            (onChange)="onToggleStatus(model)"
          >
          </p-inputSwitch>
        </td>

            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Add Item Dialogue Modal -->
<p-dialog [(visible)]="showModal" [style]="{width: '450px' , height:'400px'}" [header]="modalTitle" [modal]="true"
    styleClass="p-fluid" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="content">
        <div class="field">
            <label for="name" style="font-size: medium;">{{"common.name" |translate}}</label>
            <input type="text" pInputText id="name" [(ngModel)]="model.name" required />
        </div>
        <br>
        <div class="field">
            <label for="companyName" style="font-size: medium;">Company Name</label>
            <input type="text" pInputText id="companyName" [(ngModel)]="model.companyName" />
        </div>
        <br>
        <div class="field">
            <label for="address" style="font-size: medium;">Address</label>
            <input type="text" pInputText id="address" [(ngModel)]="model.address" />
        </div>
        <br>
        <div class="field">
            <label for="location" style="font-size: medium;">Location</label>
            <input type="text" pInputText id="location" [(ngModel)]="model.location" />
        </div>
        <br>
        <div
         class="field">
             <label for="isTestLab" style="font-size: medium;">is Test Lab</label>
             <p-dropdown resetFilterOnHide="true" id="isTestLab" name="isTestLab" [options]="stateOptions"  appendTo="body" 
                 [(ngModel)]="model.isTestLab" placeholder="Select" optionLabel="label" optionValue="value"
                 ngModel>
             </p-dropdown>
        </div>
        <br>
        <div class="field">
            <label for="isTestingBody" style="font-size: medium;">is Testing Body</label>
            <p-dropdown resetFilterOnHide="true" id="isTestingBody" name="isTestingBody" [options]="stateOptions"  appendTo="body" 
                [(ngModel)]="model.isTestingBody" placeholder="Select" optionLabel="label" optionValue="value"
                ngModel>
            </p-dropdown>
       </div>
       <div class="field">
            <label for="isCertificationBody" style="font-size: medium;">Is Certification Body</label>
            <p-dropdown resetFilterOnHide="true" id="isCertificationBody" name="isCertificationBody" [options]="stateOptions"  appendTo="body" 
                [(ngModel)]="model.isCertificationBody" placeholder="Select" optionLabel="label" optionValue="value"
                ngModel>
            </p-dropdown>
        </div>
        <div class="field">
            <label for="name" style="font-size: medium;">Institute Type <span style="">*</span> </label>
            <p-dropdown id="partner" name="partner" [options]="instituteTypelist"
                appendTo="body" [(ngModel)]="model.instituteTypeId" placeholder="Select"
                optionLabel="name" optionValue="id" [ngClass]="{'ng-invalid ng-dirty': showInstituteTypeError}">
            </p-dropdown>
            <small class="p-error" *ngIf="showInstituteTypeError">Institute Type is required.</small>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'commonbtn.cancel'|translate}}" icon="pi pi-times" class="btn-cancle"
            (click)="showModal=false"></button>
        <button pButton pRipple label="{{'commonbtn.save' | translate}}" icon="pi pi-check" styleClass="btn-save" 
            (click)="handleSaveClick(model)"></button>
    </ng-template>
</p-dialog>
<!-- End Region : Add Item Modal -->